<template>
  <dx-grid
    url="paymentPickup"
    :columns="columns"
    :title="title"
    :expandedOptions="{
      enabled: true,
      template: 'payment-pickup-details',
    }"
    :onRowClicked="onRowClicked"
    navigationPath="onRowClicked"
    navigationField="onRowClicked"
  ></dx-grid>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../utils/helpers.js";

export default {
  data: () => ({
    title: "Payment Pickups",
    columns: [
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          switch (value) {
            case "Completed":
              return "mdi-check-circle";
            case "Pending":
              return "mdi-clock";
            default:
              return "";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "Completed":
              return "success";
            case "Pending":
              return "#fdb400";
            default:
              return "#aeb8bf";
          }
        },
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Hebrew Name",
        field: "nameH",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Account ID",
        field: "accountID",
        link: "Account View",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Entered On",
        field: "enteredOn",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Pickup Date",
        field: "pickupDate",
        type: "date",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Amount",
        field: "amount",
        type: "number",
        format: {
          type: "currency",
          precision: 2,
        },
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Status",
        field: "status",
        visible: true,
        filterValues: [],
        filterValue: "Pending",
        selectedFilterOperation: null,
      },
      {
        label: "Pickup Address",
        field: "pickupAddress",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Phone Numbers",
        field: "phoneNumbers",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Messenger",
        field: "messenger",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Messenger Phone",
        field: "messengerPhone",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Entered By",
        field: "enteredBy",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Updated By",
        field: "updatedBy",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Updated At",
        field: "updatedAt",
        type: "date",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  methods: {
    async onRowClicked(row) {
      this.$router.push({
        name: "Account View",
        params: {
          id: row.accountID,
        },
        query: {
          paymentPickupID: row.id,
        },
      });
    },
  },
};
</script>
<style></style>
